export const timeLoggerBaseUrl = 'https://app.atimelogger.pro'
// export const timeLoggerBaseUrl = 'http://localhost:8090'


